// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"9b34b091","977":"8eb5befb"}[chunkId] + ".chunk.js";
};